import * as React from 'react';
import {connect} from 'react-redux';
import FormSelect from 'cl-form/FormSelect';
import * as _ from 'lodash';
import {StoreState} from "../../../../App/initialStore";

export default connect((state: StoreState) => {
  return {
    options: _.map(state.accountPage.accounts, ({UserID}) => ({value: UserID}))
  };
}, {})(FormSelect);
